// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartSplitType = createAction('[Fund Chart] Set split type', props());
